import { Entity, EntityParams } from './Entity';

export type EntityKey = number | string;

export abstract class EntityId<T extends EntityKey> extends Entity<T> {
  name: string;

  protected constructor(params: EntityIdParams<T>) {
    super(params);
    this.name = params.name;
  }
}

export type EntityIdParams<T extends EntityKey> = EntityParams<T> & {
  name: string;
};
